<template>
  <div class="container-steps">
    <span class="step"
          :class="{'active': active === 1}">1</span>
    <span class="step"
          :class="{'active': active === 2}">2</span>
    <span class="step"
          :class="{'active': active === 3}">3</span>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss">
@import './steps.sass';
</style>
